import React from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import DownloadLink from './DownloadLink';
import CancelAction from './Actions/CancelAction';
import RescheduledAction from './Actions/RescheduleAction';

import { Can } from '../../../../_contexts/AbilitiesContext'

export default function ReadyActions({ telehealth }) {
  return <div>
    <OverlayTrigger placement="top" overlay={<Tooltip>View</Tooltip>} >
      <Link className="btn btn-outline-primary btn-sm" to={`/telehealth/${telehealth.id}/view`}><i className="fa fa-list-alt"></i></Link>
    </OverlayTrigger>
    &nbsp;
    
    <DownloadLink telehealth={telehealth} small />
    &nbsp;

    <Can I="reschedule" a="telehealth">
      <RescheduledAction telehealth={telehealth} /> &nbsp;
    </Can>

    <Can I="cancel" a="telehealth">
      <CancelAction telehealth={telehealth} />
    </Can>
  </div>
}